/*** IMPORTS FROM imports-loader ***/
(function() {

define([
  'pip-model',
  'pip-events',
  'window'
],
function(
  pip,
  pipEvents,
  window
){

  function initEventListeners(){
    pipEvents.aisleAndBay.aisleAndBayTooltipOpened.on(function() {
      pushAnalyticsEvent('aisleAndBayTooltipOpened');
    });

    pipEvents.aisleAndBay.aisleAndBayTextMeClicked.on(function() {
      pushAnalyticsEvent('aisleAndBayTextMeClicked');
    });

    pipEvents.aisleAndBay.aisleAndBayTextMeClickedWithCoupon.on(function() {
      pushAnalyticsEvent('aisleAndBayTextMeClickedWithCoupon');
    });

    pipEvents.aisleAndBay.aisleAndBayTextMeErrorHappened.on(function(eventName, error) {
      pushAnalyticsEvent('aisleAndBayTextMeErrorHappened', error);
    })
  }

  function getEventObject(eventName, error) {
    var thdAnalyticsEventObject = {};
    
    switch(eventName) {
      case 'aisleAndBayTooltipOpened':
        thdAnalyticsEventObject = {
          category: {
            primaryCategory: 'interaction'
          },
          eventInfo: {
            eventName: 'pip sub-content'
          },
          subContent: {
            section: 'buybox',
            component: 'custom options',
            target: 'text me'
          }
        };
        break;
      case 'aisleAndBayTextMeClicked':
        thdAnalyticsEventObject = {
          category: {
            primaryCategory: 'button submission',
          },
          eventInfo: {
            eventName: 'text me'
          }
        };
        break;
      case 'aisleAndBayTextMeClickedWithCoupon':
        thdAnalyticsEventObject = {
          category: {
            primaryCategory: 'button submission',
          },
          eventInfo: {
            eventName: 'text me coupon'
          }
        };
        break;
      case 'aisleAndBayTextMeErrorHappened':
        if (!error) return;

        var isClientError = error.status >= 400 && error.status < 500;

        thdAnalyticsEventObject = {
          category: {
            primaryCategory: 'error'
          },
          eventInfo: {
            error: {
              code: error.status,
              displayType: 'inline',
              message: error.statusText,
              pageSection: 'aisle and bay',
              type: isClientError ? 'client' : 'system'
            }
          }
        };
        break;
      default:
        break;
    }

    return thdAnalyticsEventObject;
  }

  function pushAnalyticsEvent(eventName, error) {
    var thdAnalyticsEventObject = getEventObject(eventName, error);

    if (pip.debugMode) {
      console.log('DDO Aisle And Bay: ' + eventName, thdAnalyticsEventObject);
    }

    if (window.digitalData && window.digitalData.event) {
      window.digitalData.event.push(thdAnalyticsEventObject);
    }
  }

  return {
    init: function init() {
      initEventListeners();
    }
  }
});

}.call(window));